<template>
  <div class="chat" :class="{ 'chat-left': recebida }">
    <div class="chat-avatar">
      <b-avatar size="36" :variant="corAvatar" :text="iniciais" />
    </div>
    <div class="chat-body">
      <div class="chat-content">
        <small v-if="rotuloRemetente" class="d-block font-weight-bolder mb-25">
          {{ rotuloRemetente }}
        </small>

        <template v-if="ehMidia">
          <div v-if="!midiaUrl" class="midia-carregando">
            <feather-icon icon="LoaderIcon" class="spin" />
            Baixando {{ rotuloTipo }}...
          </div>
          <template v-else>
            <img
              v-if="mensagem.tipo === 'imagem' || mensagem.tipo === 'sticker'"
              :src="midiaUrl"
              class="midia-imagem"
              @click="abrirLightbox"
            />
            <audio v-else-if="mensagem.tipo === 'audio'" :src="midiaUrl" controls class="midia-audio" />
            <video v-else-if="mensagem.tipo === 'video'" :src="midiaUrl" controls class="midia-video" />
            <a v-else-if="mensagem.tipo === 'documento'" :href="midiaUrl" target="_blank" class="midia-documento">
              <feather-icon icon="FileTextIcon" size="20" class="mr-50" />
              {{ mensagem.texto || 'Documento' }}
            </a>
          </template>
          <p v-if="mensagem.texto && mensagem.tipo !== 'documento'" class="mt-50 mb-0" style="white-space: pre-wrap;">
            {{ mensagem.texto }}
          </p>
        </template>

        <p v-else style="white-space: pre-wrap;">
          {{ conteudoTexto }}
        </p>

        <div class="d-flex justify-content-end align-items-center mt-25">
          <small class="mr-25" :style="{ opacity: 0.7 }">{{ hora }}</small>
          <feather-icon
            v-if="!recebida"
            :icon="iconeStatus"
            size="14"
            :class="mensagem.status === 'lido' ? 'text-info' : ''"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar } from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

const TIPOS_MIDIA = ['imagem', 'audio', 'video', 'documento', 'sticker']

export default {
  components: { BAvatar, FeatherIcon },
  props: {
    mensagem: { type: Object, required: true },
  },
  computed: {
    recebida() {
      return this.mensagem.direcao === 'entrada'
    },
    ehMidia() {
      return TIPOS_MIDIA.includes(this.mensagem.tipo)
    },
    midiaUrl() {
      return this.mensagem.midia ? this.mensagem.midia.url_assinada : null
    },
    rotuloTipo() {
      const mapa = { imagem: 'imagem', audio: 'áudio', video: 'vídeo', documento: 'documento', sticker: 'figurinha' }
      return mapa[this.mensagem.tipo] || this.mensagem.tipo
    },
    rotuloRemetente() {
      if (this.mensagem.remetente_tipo === 'bot') return 'URA'
      if (this.mensagem.remetente_tipo === 'operador') {
        return this.mensagem.remetente_user ? this.mensagem.remetente_user.name : 'Operador'
      }
      if (this.mensagem.remetente_tipo === 'sistema') return 'Sistema'
      return null
    },
    corAvatar() {
      if (this.recebida) return 'light-secondary'
      if (this.mensagem.remetente_tipo === 'bot') return 'light-info'
      if (this.mensagem.remetente_tipo === 'sistema') return 'light-secondary'
      return 'light-primary'
    },
    iniciais() {
      if (this.recebida) return 'C'
      if (this.mensagem.remetente_tipo === 'bot') return 'B'
      if (this.mensagem.remetente_tipo === 'sistema') return 'S'
      return 'O'
    },
    conteudoTexto() {
      if (this.mensagem.texto) return this.mensagem.texto
      return '[' + this.mensagem.tipo + ']'
    },
    hora() {
      if (!this.mensagem.created_at) return ''
      return new Date(this.mensagem.created_at).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    },
    iconeStatus() {
      const mapa = {
        pendente: 'ClockIcon',
        enviado: 'CheckIcon',
        entregue: 'CheckIcon',
        lido: 'CheckIcon',
        falhou: 'AlertCircleIcon',
      }
      return mapa[this.mensagem.status] || 'ClockIcon'
    },
  },
  methods: {
    abrirLightbox() {
      window.open(this.midiaUrl, '_blank')
    },
  },
}
</script>

<style scoped>
.midia-imagem {
  max-width: 260px;
  max-height: 260px;
  border-radius: 6px;
  cursor: pointer;
  display: block;
}
.midia-audio {
  max-width: 260px;
}
.midia-video {
  max-width: 260px;
  border-radius: 6px;
  display: block;
}
.midia-documento {
  display: flex;
  align-items: center;
}
.midia-carregando {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  opacity: 0.7;
}
.spin {
  animation: girar 1s linear infinite;
}
@keyframes girar {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
